/*
import React, {useState} from 'react';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    margin: 10,
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  header: {
    marginBottom: 10,
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  details: {
    fontSize: 14,
    marginBottom: 10,
  },
  table: {
    display: 'table',
    width: 'auto',
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    alignItems: 'center',
  },
  tableCell: {
    flex: 1,
    padding: 5,
  },
  productImage: {

     flex: 1,
    padding: 5,
  },
  total: {
    marginTop: 10,
    fontSize: 16,
    marginRight: 30,
    fontWeight: 'bold',
    textAlign: 'right',
  },
});

const Invoice = ({ data }) => {

   const generateRandomInvoiceNumber = () => {
    return Math.floor(1000 + Math.random() * 9000); // Generates a random 4-digit number
  };

  const [invoiceNumber] = useState(generateRandomInvoiceNumber());

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <View style={styles.header}>
            <Text style={styles.title}>Maokoto Invoice</Text>
          </View>
          <View style={styles.details}>
            <Text>Invoice Number:  {invoiceNumber}</Text>
            <Text> Invoice Date: {new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })}</Text>
          </View>
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <Text style={styles.tableCell}>Photo</Text>
               <Text style={styles.tableCell}>Name</Text>
              <Text style={styles.tableCell}>Price</Text>
              <Text style={styles.tableCell}>Qty</Text>
              <Text style={styles.tableCell}>Size</Text>
              <Text style={styles.tableCell}>Total</Text>
            </View>

            <View style={styles.tableRow}>
              <Image src={data.product.photo} style={styles.productImage} />
              <Text style={styles.tableCell}>{data.product.name.split('-')[0]}</Text>
              <Text style={styles.tableCell}>{data.product.price}</Text>
              <Text style={styles.tableCell}>{data.Qty}</Text>
               <Text style={styles.tableCell}>{data.selectedSize}</Text>
              <Text style={styles.tableCell}>
               {/!* ${Number(data.price) * Number(data.quantity)}*!/}
                {(
                  parseFloat(data.product.price.replace(/,/g, '')) *
                  parseFloat(data.Qty)
                ).toLocaleString('en-TZ', {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                })}
              </Text>
            </View>
          </View>
          <Text style={styles.total}>
          {/!*  Total: ${Number(data.price) * Number(data.quantity)}*!/}
           Tsh  {(
                  parseFloat(data.product.price.replace(/,/g, '')) *
                  parseFloat(data.Qty)
                ).toLocaleString('en-TZ', {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                })}
          </Text>
        </View>
      </Page>
    </Document>
  );
};

export default Invoice;
*/
import React, { useState } from 'react';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    margin: 10,
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  header: {
    marginBottom: 10,
    backgroundColor: '#333',
    padding: 10,
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#fff',
  },
  details: {
    fontSize: 14,
    marginBottom: 10,
  },
  table: {
    display: 'table',
    width: 'auto',
    border: '1px solid #333',
     textAlign: 'right',
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    alignItems: 'center',
     textAlign: 'right',
  },
  tableHeader: {
    fontWeight: 'bold',
    backgroundColor: '#eee',
    padding: 5,
    textAlign: 'center',
  },
  tableCell: {
    flex: 1,
    padding: 5,
    textAlign: 'center',
  },
  productImage: {
    flex: 1,
    padding: 5,
    maxWidth: 50,
  },
  total: {
    marginTop: 10,
    fontSize: 16,
    marginRight: 30,
    fontWeight: 'bold',
    textAlign: 'right',
  },
});

const Invoice = ({ data }) => {
  const generateRandomInvoiceNumber = () => {
    return Math.floor(1000 + Math.random() * 9000); // Generates a random 4-digit number
  };

  const [invoiceNumber] = useState(generateRandomInvoiceNumber());

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <View style={styles.header}>
            <Text style={styles.title}>Maokoto Invoice</Text>
          </View>
          <View style={styles.details}>
            <Text>Invoice Number: {invoiceNumber}</Text>
            <Text>Invoice Date: {new Date().toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}</Text>
          </View>
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <Text style={styles.tableCell}>Photo</Text>
              <Text style={styles.tableCell}>Name</Text>
              <Text style={styles.tableCell}>Price</Text>
              <Text style={styles.tableCell}>Qty</Text>
              <Text style={styles.tableCell}>Size</Text>
              <Text style={styles.tableCell}>Total</Text>
            </View>

            <View style={styles.tableRow}>
              <Image src={data.product.photo} style={styles.productImage} />
              <Text style={styles.tableCell}>{data.product.name.split('-')[0]}</Text>
              <Text style={styles.tableCell}>{data.product.price}</Text>
              <Text style={styles.tableCell}>{data.Qty}</Text>
              <Text style={styles.tableCell}>{data.selectedSize}</Text>
              <Text style={styles.tableCell}>
                {(
                  parseFloat(data.product.price.replace(/,/g, '')) *
                  parseFloat(data.Qty)
                ).toLocaleString('en-TZ', {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                })}
              </Text>
            </View>
          </View>
          <Text style={styles.total}>
            Tsh {(
              parseFloat(data.product.price.replace(/,/g, '')) *
              parseFloat(data.Qty)
            ).toLocaleString('en-TZ', {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            })}
          </Text>
        </View>
      </Page>
    </Document>
  );
};

export default Invoice;
